import { Block, PreviewType } from '../block.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('MainLayoutSidebarToggleButtonBlock')
export class MainLayoutSidebarToggleButtonBlock extends Block {
	@jsonProperty()
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 1,
		label: 'Only show on handsets',
	})
	onlyShowOnHandsets: boolean = true

	constructor(init: Partial<MainLayoutSidebarToggleButtonBlock> = {}) {
		super()
		this.init(init)
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#78909c'
	}

	getTitleColor(): string {
		return 'white'
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	producePreview(): PreviewType {
		return {
			type: 'icon',
			fontIcon: 'menu',
			fontSet: 'material-icons',
		}
	}
}
